module.exports = __webpack_public_path__ + "static/Zei-97d1a5d123531b85d472e07bb7e88182.jpg";